import React from 'react'
import styles from 'components/cases/common/Overview/Overview.module.scss'
import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/OverviewHeight/OverviewHeight'
import { CaseStudyItems } from 'components/cases/common/CaseStudy/CaseStudy'
import { CaseCTAItem } from 'components/cases/common/CaseCTA'
import { CaseDownloadCTAItem } from 'components/cases/common/CaseDownloadCTA'

// ファーストビュー
export const firstViewItemWhite = {
  breadcrumb: 'アジャイル開発によりWebサービスのアプリ化を2か月半で実現',
  title1: (
    <>
      アジャイル開発により
      <br />
      Webサービスのアプリ化を2か月半で実現
    </>
  ),
  company: '株式会社SANU',
  introduction_text: (
    <>
      「Live with Nature. / 自然と共に生きる。」を掲げ「SANU 2nd
      Home」を運営するSANUは、都市と自然を軽やかに行き来するライフスタイルをより身近にするため、自社アプリの開発に踏み切りました。
      <br />
      従来はWebとメールでの作業が中心だったため利便性に課題がありましたが、リソース不足が壁となっていました。これに対しAitriaは、徹底した事前環境構築により並行開発を可能にし、実質2か月半という短納期でのリリースを実現しました。
    </>
  ),
  tag1text: 'アプリケーション開発',
  tag1src: '/cases/application-development/',
  tag2text: 'フロントエンド開発',
  tag2src: '/cases/frontend-dev/',
  industryTagText: 'サービス',
  industryTagSrc: '/cases/service/',
  image: '/images/img/cases/sanu/mv.webp',
  movie: '',
  alt: '株式会社SANU アジャイル開発によりWebサービスのアプリ化を2か月半で実現',
}

// プロジェクト概要
export const overviewTitle = 'アニバーサリーイベントに間に合わせた、実質2か月半のモバイルアプリ開発'

export const overviewItem: OverviewItems[] = [
  {
    text: 'セカンドホームサービス「SANU 2nd Home」を運営する株式会社SANUは、滞在体験の改善に向けてモバイルアプリの開発を計画していました。',
  },
  {
    text: '従来はWebブラウザとメールで予約を管理していましたが、メールから予約情報を探すのが手間となっており、プッシュ通知で即座にアクセスできるといったモバイルアプリならではの利便性が求められていました。',
  },
  {
    text: (
      <>
        しかし既存のWeb開発や新機能開発と並行してアプリ開発を進める必要があり、人的リソースを割くことができない状況でした。Aitriaは、
        <span className={styles.textbold}>
          プロジェクト開始前からの徹底的な環境構築により、実質2か月半という短納期でのアプリ開発を実現
        </span>
        しました。
      </>
    ),
  },
  {
    text: '今回は、SANU 2nd Home アプリ開発責任者の小笠原さん、Aitria プロジェクトマネージャー・テックリードの桐生の2名に、プロジェクトの舞台裏を伺いました。',
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        title: '既存開発と並行したアプリ開発の困難',
        text: '既存のWeb開発や新機能開発を並行して進めており、アプリ開発に人的リソースを割くことができない状況だった。',
      },
      {
        title: 'Webとメールの組み合わせによる体験の限界',
        text: 'メールから予約情報を探す手間が発生。プッシュ通知などスマートフォン時代の「当たり前」の体験が提供できていなかった。',
      },
    ],
    solutions: [
      {
        title: 'プロジェクト開始前にインフラと技術環境を構築',
        text: '開始1週間前から開発に使用するツールなどの事前準備を行い、即座に開発着手。GraphQLで画面変更に強い設計をするなど、両社の協働により約2.5倍の開発スピードを達成。',
      },
      {
        title: '仕様確定前から先行実装し、変更に即座に対応',
        text: '仕様が固まっていない部分も予測して仮実装を先行。決定後すぐに変更・反映できる柔軟な構成で開発スピードを維持。',
      },
      {
        title: '実機で毎日検証し、手戻りを最小化',
        text: 'TestFlightで当日〜翌日にフィードバックが返る高速なプロセスを、両社で協力することにより実現。早期検証で手戻りを防ぎ、確実な納期達成に貢献。',
      },
    ],
  },
]

// CTA
export const caseCTAItem: CaseCTAItem = {
  title: '「仕様が固まらない」を、AI駆動で待ち時間にしない。',
  description:
    '仕様が固まっていない段階からでも、AI駆動開発で変化に即対応し、短期リリースを実現します。まずは、現在の課題やお悩みをお聞かせください。',
}

// 資料ダウンロード CTA
export const caseDownloadCTAItem: CaseDownloadCTAItem = {
  title: 'アプリ開発RFP作成のポイント',
  description: 'アプリ開発担当者向けに、失敗しないためのポイントをテンプレート付の1冊にまとめました',
  imageSrc: '/images/img/cases/cta_rfp.webp',
  href: '/download/rfp/',
}

// 関連事例
export const caseStudyItem: CaseStudyItems = [
  {
    projectName: '【技術系災害ボランティア体験】家屋再生〜水害編〜',
    client: '公益財団法人日本財団ボランティアセンター様',
    src: '/images/img/case/img_case_volunteer-ex.png',
    alt: '公益財団法人日本財団ボランティアセンター様',
    href: '#',
    tags: [{ name: 'XR/メタバース導入', url: 'xr' }],
  },
  {
    projectName: 'PEACH JOHN',
    client: '株式会社ピーチ・ジョン様',
    src: '/images/img/case/img_peachjohn.png',
    alt: '株式会社ピーチ・ジョン様',
    href: '#',
    tags: [
      { name: 'UX/UIデザイン', url: 'uiux' },
      { name: 'アプリケーション開発', url: 'application-development' },
      { name: '小売', url: 'service' },
    ],
  },
  {
    projectName: 'セブンネットショッピング「推し活倶楽部」',
    client: '株式会社セブンネットショッピング様',
    src: '/images/img/case/img_sevennet.png',
    alt: '株式会社セブンネットショッピング様',
    href: '#',
    tags: [
      { name: 'UX/UIデザイン', url: 'uiux' },
      { name: 'アーキテクチャ設計サービス', url: 'architecture-design' },
      { name: '小売', url: 'service' },
    ],
  },
]
